import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TemplateClassNames } from "../../../types/template-layouts";
import useTimeout from "../../../utils/use-timeout";
import { TypographyItem } from "../typography-item/typography-item";
import "./countdown.scss";

export const Countdown: React.FC<{
	date: Date;
	template?: TemplateClassNames;
}> = ({ date, template }) => {
	const [second, setSecond] = useState(0);
	const [minute, setMinute] = useState(0);
	const [hour, setHour] = useState(0);
	const [day, setDay] = useState(0);
	const { t } = useTranslation("homepage");
	const { runWithTimeout } = useTimeout(() => {
		update();
		runWithTimeout();
	}, 1000);

	const isEnd = useCallback(() => {
		const today = new Date();
		const msBetween = date.valueOf() - today.valueOf();
		return msBetween <= 0;
	}, [date]);

	const update = useCallback((): void => {
		const today = new Date();
		let msBetween = date.valueOf() - today.valueOf();
		msBetween = Math.max(msBetween / 1000, 0);
		setSecond(Math.floor(msBetween % 60));
		msBetween = msBetween / 60;
		setMinute(Math.floor(msBetween % 60));
		msBetween = msBetween / 60;
		setHour(Math.floor(msBetween % 24));
		setDay(Math.floor(msBetween / 24));
	}, [date]);

	useEffect(() => {
		update();

		if (!isEnd()) {
			runWithTimeout();
		}
	}, [update, runWithTimeout, isEnd]);

	return (
		<div className={`countdown-container ${template}`}>
			<div>
				<TypographyItem className="countdown-number evt-heading-1">
					{day}
				</TypographyItem>
				<div className="countdown-label">{t("DAYS")}</div>
			</div>
			<div className="countdown-separator">:</div>
			<div>
				<TypographyItem className="countdown-number evt-heading-1">
					{hour}
				</TypographyItem>
				<div className="countdown-label">{t("HOURS")}</div>
			</div>
			<div className="countdown-separator">:</div>
			<div>
				<TypographyItem className="countdown-number evt-heading-1">
					{minute}
				</TypographyItem>
				<div className="countdown-label">{t("MINUTES")}</div>
			</div>
			<div className="countdown-separator">:</div>
			<div>
				<TypographyItem className="countdown-number evt-heading-1">
					{second}
				</TypographyItem>
				<div className="countdown-label">{t("SECONDS")}</div>
			</div>
		</div>
	);
};
